<template>
  <div class="animated fadeIn col-md-12">
    <b-card border-variant="default" :no-body="false">
      <div slot="header">
        <strong v-text="$lang.azmoonLang.azmoon_execute_links"></strong>
      </div>
      <LoadingSpinner :loading="isLoading" />
      <b-row v-if="!isLoading && items.length" class="my-2">
        <b-col
          cols="12"
          v-for="(item, index) in items"
          :key="index + `audience`"
        >
          <a
            target="_blank"
            class="btn btn-info text-white m-2"
            :href="pathOr('', ['address'], item)"
            v-text="
              `${pathOr('', ['exam_pack', 'id'], item)}- ${pathOr(
                '',
                ['exam_pack', 'name'],
                item
              )}`
            "
          />
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import LoadingSpinner from "@/components/base/LoadingSpinner";
import { pathOr } from "ramda";
import { generateApiUrl } from "@/shared/utils";

export default {
  name: "azmoon-execute-links",
  components: { LoadingSpinner },
  inject: ["researchAzmoonExecutePersonReferenceRepository"],
  props: {
    azmoonExecuteId: {
      type: [String, Number],
      required: true,
    },
    personCode: {
      type: [String, Number],
      required: true,
    },
    operatorCode: {
      type: [String, Number],
      required: true,
    },
    referenceCode: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      modalTitle: "",
      message: "",
      removemodal: false,
      mode: "",
      isCollapsed: false,
      itemId: null,
      itemResearcher: null,
      audience: {},
      img_kind: this.$config.images.shared.noPerson,
      reference: {},
      id: this.$route.params.id,
      url: this.$config.api_url + this.$config.azmoon.research_plan,
      hiddenFields: [
        "research_contact_description",
        "research_visit_description",
      ],
      isLoading: false,
      isLoadingBtn: false,
      view_add: false,
      items: [],
      reserach: {},
      locations: {},
      research_complete: 0,
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    pathOr,
    async fetchData() {
      this.isLoading = true;
      try {
        const url = generateApiUrl(
          ["resources", "azmoon_execute_links"],
          [
            this.azmoonExecuteId,
            this.personCode,
            this.operatorCode,
            this.referenceCode,
          ]
        );
        const response = await this.$httpService.get(url);
        this.items = pathOr([], ["data", "data"], response);
      } catch (error) {
        this.$generateError(error);
      }
      this.isLoading = false;
    },
  },
};
</script>
